export const getEnumTypeGuard =
  <T extends object | null>(e: T) =>
  (token: unknown): token is T[keyof T] =>
    e != null && Object.values(e).includes(token as T[keyof T]);

export const getEnumKeyTypeGuard =
  <T extends object | null>(e: T) =>
  (token: PropertyKey): token is keyof T =>
    e != null && Object.keys(e).includes(token.toString());
